<template>
<div class="profile-wrapper" v-if="user">
  <div class="profile">
    <div class="header">
      {{ user.name }} {{ user.lastName }}
    </div>
    <div class="account-data">
      <div
        class="user-image"
        :style="{ backgroundImage: `url('/qr.png')` }">
      </div>
      <div>Reservar</div>
      <div v-if="!ready"  style="padding: 10px 0">
        <datetime v-model="date" type="datetime"></datetime>
      </div>
      <div v-if="!ready"  style="padding: 10px 0; font-size: 20px; display: flex; align-items: center;">
        <div><img @click="quantity--" style="height: 20px; width: auto;" src="https://cdns.iconmonstr.com/wp-content/assets/preview/2012/240/iconmonstr-minus-2.png"></div>
        <div style="padding: 0 20px">{{ quantity }}</div>
        <div><img @click="quantity++" style="height: 20px; width: auto;" src="https://cdns.iconmonstr.com/wp-content/assets/preview/2012/240/iconmonstr-plus-2.png"></div>
      </div>
      <div class="button" v-if="!ready" @click="ready = true">Reservar</div>
      <div class="button-empty" v-if="ready">Listo. Te estamos esperando</div>
    </div>
    <div class="subtitle">
      Ultimas visitas
    </div>
    <div class="visit-card">
      <div class="visit-card-name">Sonora Grill</div>
      <div class="visit-card-value">$780.52</div>
      <div class="visit-card-date">12 de septiembre</div>
    </div>
    <div class="visit-card">
      <div class="visit-card-name">Sonora Grill</div>
      <div class="visit-card-value">$620.12</div>
      <div class="visit-card-date">1 de septiembre</div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import { createNamespacedHelpers } from 'vuex';
import 'vue-datetime/dist/vue-datetime.css';

const { mapState } = createNamespacedHelpers('user');
export default {
  data() {
    return {
      data: {
        profileImgUrl: '',
      },
      time: Date.now(),
      quantity: 1,
      moment,
      ready: false,
    };
  },
  methods: {
    goToProjects() {
      window.location.replace('/#projects');
    },
  },
  computed: {
    dataCompleted() {
      const keys = [
        'birthday',
        'curp',
        'workCompany',
        'nationality',
        'isPep',
        'isPepRelated',
        'officialIdUrl',
      ];

      for (let i = 0; i < keys.length; i += 1) {
        const element = keys[i];
        if (this.user[element] === null || this.user[element] === '') {
          return false;
        }
      }
      return true;
    },
    ...mapState([
      'user',
      'token',
    ]),
  },
  components: {
    datetime: Datetime,
  },
  mounted() {
    moment.locale('es');
  },
};
</script>

<style lang="scss" scoped>
.profile-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #fafafa;
  font-family: 'Inter', sans-serif;
}
.profile {
  width: 900px;
  padding: 90px 20px;
  display: flex;
  flex-direction: column;
}
.header {
  width: 100%;
  display: flex;
  padding: 15px 0;
  color: #202124;
  font-size: 28px;
  font-weight: bold;
}
.verify {
  width: 100%;
  padding: 30px 25px;
  border-radius: 8px;
  background-color: #e5ebfb;
  color: black;
  margin-top: 18px;
}
.green {
  background-color: #e6f5ee !important;

  .verify-button {
    background-color: #3fc67d;
  }
}
.verify-title {
  font-size: 28px;
  font-weight: bolder;
  margin-bottom: 16px;
}
.verify-text {
  font-size: 16px;
  line-height: 20px;
}
.verify-action {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.verify-button {
  background-color: #3479e9;
  color: white;
  padding: 12px 20px;
  display: flex;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
}
.account-data {
  border: 1px solid #e8e8e8;
  padding: 20px;
  border-radius: 6px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.user-image {
  width: 24%;
  padding-bottom: 24%;
  background-size: cover;
}
.user {
  width: 68%;
}
.name {
  font-weight: bolder;
  font-size: 32px;
}
.user-info {
  margin-top: 16px;
}
.user-label {
  color: rgb(177, 176, 176);
  margin-bottom: 5px;
}
.subtitle {
  width: 100%;
  display: flex;
  padding: 15px 0;
  color: #202124;
  font-size: 18px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 8px;
}
.visit-card {
  border: 1px solid #e8e8e8;
  padding: 16px;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;

  & + .visit-card {
    margin-top: 20px;
  }
}
.visit-card-name {
  width: 75%;
  font-weight: 600;
  margin-bottom: 8px;
}
.visit-card-date {
  width: 100%;
  color: gray;
}
.visit-card-value {
  width: 25%;
}
.button {
  background-color: #3479e9;
  color: white;
  margin-top: 10px;
  padding: 10px 30px;
  font-size: 14px;
  cursor: pointer;
}
.button-empty {
  color: black;
  margin-top: 10px;
  padding: 10px 30px;
  font-size: 14px;
  cursor: pointer;
}
@media only screen and (max-width: 500px) {
  .account-data {
    flex-direction: column;
  }
  .user-image {
    width: 60%;
    padding-bottom: 60%;
  }
  .user {
    width: 100%;
  }
}
</style>
